// const BACK_URL = "http://localhost:80"
const BACK_URL = "https://gundam-back.onrender.com"

export default BACK_URL